import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NewSofortTransaction } from '../../dto/new-sofort-transaction';
import {SofortPaymentModel} from '../../models/sofort-payment-model';

@Injectable()
export class SofortPaymentService {

    readonly apiPath = environment.baseUrl + 'sofort-payment/';
    readonly headers = { headers: new HttpHeaders({ 'No-Auth': 'True' }) };
    constructor(
        private http: HttpClient,
    ) { }

    initializeSofortPayment(spm: SofortPaymentModel): Observable<NewSofortTransaction> {
        return this.http.post(this.apiPath+ 'initialize-payment', spm) as Observable<NewSofortTransaction>;
    }
}
